import React, { useState, useEffect } from 'react';
import log from 'loglevel';
import Fitness from '../Fitness';

function Themes() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedTheme, setSelectedTheme] = useState('fitness');

  const themeResources = {
    fitness: {
      component: <FitnessWrapper />, // Use a wrapper component
      css: [
        './animate.min.css',
        './bootstrap.min.css',
        './owl.carousel.min.css',
        './FitnessCss/App.css'
      ]
    }
  };

  // Wrapper component to ensure Fitness doesn't render a Router
  function FitnessWrapper() {
    return <Fitness />;
  }

  const loadTheme = async (themeKey) => {
    setLoading(true);
    setError(null);
    
    try {
      for (const cssPath of themeResources[themeKey].css) {
        try {
          await import(/* webpackIgnore: true */ cssPath);
          log.info(`Successfully loaded: ${cssPath}`);
        } catch (err) {
          log.warn(`Could not load CSS: ${cssPath}`, err);
        }
      }
      setSelectedTheme(themeKey);
    } catch (err) {
      setError(`Failed to load theme. ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTheme('fitness');
  }, []);

  if (loading) return <div>Loading theme...</div>;
  if (error) return <div className="text-danger">{error}</div>;

  return (
    <div className="theme-component">
      <div className="theme-selector">
        <h2>Theme Preview</h2>
        <div className="theme-options">
          <button 
            onClick={() => loadTheme('fitness')}
            className={selectedTheme === 'fitness' ? 'active' : ''}
          >
            Fitness Theme
          </button>
        </div>
      </div>
      <div className="theme-preview-container">
        {themeResources[selectedTheme].component}
      </div>
    </div>
  );
}

export default Themes;